export const editMutations = <const>{
	NAHRADNI_DILY_SKLAD_MISTO_SELECT_MAPPER: 'skladMistoSelectMapper',
	NAHRADNI_DILY_RABAT_SK_SELECT_MAPPER: 'rabatSkSelectMapper',
	NAHRADNI_DILY_PRACOVNIK_SELECT_MAPPER: 'pracovnikSelectMapper',
	NAHRADNI_DILY_NDNR_SELECT_MAPPER: 'ndNrSelectMapper',
	NAHRADNI_DILY_CLEAR_DATA: 'clearData',
	NAHRADNI_DILY_SET_BUTTONS: 'setButtons',
	NAHRADNI_DILY_SET_CONTROLS_FOR_S2: 'setControlsForS2',
	NAHRADNI_DILY_REFRESH_FORM_DATA: 'refreshFormData',
	NAHRADNI_DILY_KOPIRUJ_ND_SKLAD: 'kopirujNdSklad',
	NAHRADNI_DILY_IDENTICKY_ND: 'identickyNd',
	SET_OCENENI_ND: 'setOceneniNd',
	ND_SKLAD_ENTITY: 'setNdSkladAfterOceneni',
};

export const editActions = <const>{
	OCENENI_ND: 'oceneniNdAction',
	CHECK_EXISTS_JFND: 'checkExistsJfnd',
	GET_JFND_INPUT: 'getJfndInput',
	GET_IDENTICKY_ND: 'getIdentickyNd',
	VYDEJ_VRATKA: 'vydejVratka',
	CHECK_ND_CENIK_ID: 'checkNdCenikId',
	ND_CENIK_KDC: 'ndCenikKdc',
	DEFAULT_JFND: 'defaultJfnd',
};
